import { render, staticRenderFns } from "./ChatReplyNotice.vue?vue&type=template&id=7d7489fc&scoped=true"
import script from "./ChatReplyNotice.vue?vue&type=script&lang=js"
export * from "./ChatReplyNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7489fc",
  null
  
)

export default component.exports